function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import _ from 'lodash';
import { useFieldArray } from 'react-hook-form';
import generateCode from 'shared/helper/generate-code';
import { FILE_STATUS } from './constants';
var createFile = function createFile(props) {
  var uploadedAt = new Date().getTime();
  return _objectSpread({
    bucket: '',
    identity: '',
    name: '',
    previewUrl: '',
    remoteName: '',
    size: '',
    status: FILE_STATUS.STATUS_UPLOAD_PROCESSING,
    tid: generateCode(20, uploadedAt),
    type: '',
    uploadedAt: uploadedAt
  }, props);
};
var fileMatches = function fileMatches(fileA, fileB) {
  if (fileA.tid && fileA.tid === fileB.tid) {
    return true;
  }
  if (fileA.identity && fileA.identity === fileB.identity) {
    return true;
  }
  return false;
};
var useFiles = function useFiles(_ref) {
  var control = _ref.control,
    enablePreviews = _ref.enablePreviews,
    name = _ref.name,
    type = _ref.type;
  var _useFieldArray = useFieldArray({
      control: control,
      name: name
    }),
    files = _useFieldArray.fields,
    addFile = _useFieldArray.append,
    removeFileAtIndex = _useFieldArray.remove,
    insertFile = _useFieldArray.insert,
    updateFileAtIndex = _useFieldArray.update;
  var replaceFileAtIndex = function replaceFileAtIndex(idx, file) {
    // removeFileAtIndex(idx);
    // insertFile(idx, file);
    updateFileAtIndex(idx, file);
  };
  var addAcceptedFiles = function addAcceptedFiles(acceptedFiles) {
    var processedAcceptedFiles = acceptedFiles.map(function (file) {
      return {
        tid: generateCode(20, new Date().getTime()),
        file: file
      };
    });
    processedAcceptedFiles.forEach(function (_ref2) {
      var file = _ref2.file,
        tid = _ref2.tid;
      return addFile(createFile({
        name: file.name,
        tid: tid,
        previewUrl: enablePreviews ? URL.createObjectURL(file) : '',
        type: type,
        size: file.size
      }));
    });
    return processedAcceptedFiles;
  };
  var addRejectedFiles = function addRejectedFiles(rejectedFiles) {
    rejectedFiles.forEach(function (_ref3) {
      var file = _ref3.file;
      return addFile(createFile({
        name: file.name,
        status: FILE_STATUS.STATUS_FILETYPE_FAILURE,
        type: type
      }));
    });
  };
  var updateFiles = function updateFiles(files, acceptedFiles, rejectedFiles, status) {
    var acceptedFilesByTid = _.keyBy(acceptedFiles, 'tid');
    var rejectedFilesByTid = _.keyBy(rejectedFiles, 'tid');
    files.forEach(function (file, idx) {
      // If a file isn't being processed, no need to update it
      if (file.identity || file.status !== FILE_STATUS.STATUS_UPLOAD_PROCESSING) {
        return;
      }
      if (typeof acceptedFilesByTid[file.tid] !== 'undefined') {
        replaceFileAtIndex(idx, _objectSpread(_objectSpread(_objectSpread({}, file), acceptedFilesByTid[file.tid]), {}, {
          status: FILE_STATUS.STATUS_UPLOAD_SUCCESS
        }));
      }
      if (typeof rejectedFilesByTid[file.tid] !== 'undefined') {
        replaceFileAtIndex(idx, _objectSpread(_objectSpread(_objectSpread({}, file), rejectedFilesByTid[file.tid]), {}, {
          status: status
        }));
      }
    });
  };
  var removeFile = function removeFile(files, fileToRemove) {
    var fileIdx = files.findIndex(function (file) {
      return fileMatches(fileToRemove, file);
    });
    if (fileIdx === -1) {
      return;
    }
    removeFileAtIndex(fileIdx);
  };
  return {
    addAcceptedFiles: addAcceptedFiles,
    addRejectedFiles: addRejectedFiles,
    updateFiles: updateFiles,
    files: files,
    removeFile: removeFile
  };
};
export default useFiles;